import { browserPdfOutput, type VoyageSource } from '@felix/ui';
import { api, officeApi } from './api.js';

/**
 * Ofiste sefer verisi (ADR 0022): sefer listesi, planlama ve gemiden gelen raporlar; rapor
 * yazma yok (raporlar gemide girilir, mimari belge §8). MLC kartı geminin dinlenme raporundan.
 */
export const officeVoyageSource: VoyageSource = {
  scope: 'web',
  vessels: () => officeApi.vessels(),
  voyages: (vesselId) => officeApi.voyages(vesselId),
  // Yakıt defterinin başlangıcı (ADR 0117 Ek Y3): ROB sütunları defterden, formda salt okunur
  fuelLedgerStart: async (vesselId) =>
    (
      await api<{ ledgerStart: string | null }>(
        `/office/fuel/ledger-state?vesselId=${encodeURIComponent(vesselId)}`,
      )
    ).ledgerStart,
  reports: (voyageId) => officeApi.voyageReports(voyageId),
  departures: (vesselId) => officeApi.unlinkedDepartures(vesselId),
  // All Reports (ADR 0082): geminin bütün raporları
  allReports: (vesselId) => officeApi.vesselVoyageReports(vesselId),
  // Sefersiz raporlar, bağ önerisi ve sefer talebi (ADR 0083 §5; sahip kararı 2026-10-19, soru 1)
  unassigned: (vesselId) => officeApi.unassignedReports(vesselId),
  linkSuggestions: (voyageId, start) => officeApi.linkSuggestions(voyageId, start),
  requests: (vesselId) => officeApi.voyageRequests(vesselId),
  requestChange: (vesselId, input) => officeApi.submitVoyageRequest(vesselId, input),
  performance: (voyageId) => officeApi.voyagePerformance(voyageId),
  // Charter party (ADR 0084): ofis yazar ve karar verir
  charterParties: (vesselId) => officeApi.charterParties(vesselId),
  charterPartyAnalysis: (id) => officeApi.charterPartyAnalysis(id),
  charterPartyEditor: {
    save: (vesselId, content, existing) =>
      existing
        ? officeApi.updateCharterParty(existing.id, existing.rowVersion, content)
        : officeApi.createCharterParty(vesselId, content),
    remove: (id, rowVersion) => officeApi.removeCharterParty(id, rowVersion),
    decide: (vesselId, input) => officeApi.decideCharterParty(vesselId, input),
    review: (id, analysisHash, note) => officeApi.reviewCharterParty(id, analysisHash, note),
  },
  restHours: (vesselId, from, to) => officeApi.restHours(vesselId, from, to),
  // Ekler ve çıktı (ADR 0057 §3, §7): ekler salt okunur, ofis adresinden açılır
  attachments: (reportId) => officeApi.pmsAttachments(reportId, 'voyage_report'),
  attachmentUrl: (id) => `/api/office/attachments/${encodeURIComponent(id)}`,
  brand: async () => {
    try {
      const { branding } = await officeApi.branding();
      return branding?.name ? { name: branding.name, logo: branding.logo ?? null } : null;
    } catch {
      return null;
    }
  },
  pdf: browserPdfOutput(),
  // Seferi gemi yazar; ofis seferi ve bağı talep olarak gönderir (ADR 0022 Ek, ADR 0083 §5)
};
